const currentLang = drupalSettings.path.currentLanguage;
const switchLangBloc = document.querySelector('.language-switcher-language-url');
const langues = switchLangBloc.querySelectorAll('li');

const splitLetter = () => {
  langues.forEach(lang => {
    const txt = lang.querySelector('a').innerText;
    lang.querySelector('a').innerText = txt.substring(0, 2);
  })
}

const checkCurrentLang = () => {
  langues.forEach(lang => {
    const dataLang = lang.querySelector('a').getAttribute('hreflang');
    lang.querySelector('a').classList.add(dataLang + '-flag')
  })
}

const switchLang = () => {
  switchLangBloc.querySelector('a').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.links').classList.toggle('links--display');
    if (
      bsBreakpoints.detectBreakpoint() === 'xSmall'
    ) {
      const navReturn = document.querySelector('.responsive-return');
      navReturn.classList.toggle('responsive-return--active');
      navReturn.addEventListener('click',()=>{
        switchLangBloc.classList.remove('language-switcher-language-url--active');
        document.querySelector('.links').classList.remove('links--display');
        navReturn.classList.remove('responsive-return--active')
      })
      let linksH = 0;
      console.log(langues.length);
      langues.forEach((lang, index) => {
        let h = lang.offsetHeight;
        linksH += linksH + h;
        console.log(index, h);
      })
      switchLangBloc.classList.toggle('language-switcher-language-url--active')
    }
  })
}

const respSwitch = () => {
  if (
    bsBreakpoints.detectBreakpoint() === 'xSmall'
  ) {
    const menuResp = document.querySelector('.header__menu__responsive');
    menuResp.appendChild(switchLangBloc);
  }
}

splitLetter();
checkCurrentLang();
switchLang();
respSwitch();
 